import type { Position, Severity } from '@cobliteam/common-types';
import { useGeocode } from '@cobliteam/hooks';
import { Skeleton, Typography } from '@cobliteam/ui/components';
import { format } from '@cobliteam/utils/date';
import type { ReactNode } from 'react';
import { SeverityTag } from '../../components/MediaTags';

interface MediaTrackingPopup {
  title: string;
  position: Position;
  timestamp?: number;
  severity?: Severity;
  button?: ReactNode;
}

const MediaTrackingPopup = ({ title, position, timestamp, severity, button }: MediaTrackingPopup) => {
  const { useGetAddress } = useGeocode();
  const { data: address } = useGetAddress(position, { staleTime: Number.POSITIVE_INFINITY });

  return (
    <div className='w-[400px] space-y-3 p-3'>
      <div className='flex h-full flex-nowrap items-center gap-2'>
        <Typography as='h4' className='m-0' variant='text-md-medium'>
          {title}
        </Typography>
        {severity && <SeverityTag severity={severity} />}
        {button}
      </div>
      <div className='flex items-center'>
        <div className='flex flex-grow flex-col gap-1'>
          {address ? (
            <Typography color='secondary'>{address}</Typography>
          ) : (
            <Skeleton className='inline h-20 w-full bg-gray-3' height={20}>
              <rect x='0' y='0' width='100%' height='100%' />
            </Skeleton>
          )}
          {timestamp && <Typography color='secondary'>{format(timestamp, 'dd/MM/yyyy HH:mm:ss')}</Typography>}
        </div>
      </div>
    </div>
  );
};

export default MediaTrackingPopup;
